import { FlatInspectionResultDto } from '../core/api';
import { I18NText } from '../core/api/model/i18NText';

export class ProtocolPdfResultDto {
  public pathToElement!: string;
  public categoryName?: I18NText | null;
  public categoryShortName?: I18NText | null;
  public pointGroupNames: I18NText[] = [];
  public pointNumber?: string | null;
  public pointName?: I18NText | null;
  public inspectionResult!: FlatInspectionResultDto;
  public categoryReason?: I18NText | null;
  public displayInspectionReason?: boolean;
  public groupElementNumber?: string | null;
}
